import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Target } from "lucide-react";
import api from "@/utils/api";

// Dashboard summary of leads shared with the WhatsApp CRM. Hidden quietly if leads aren't connected.
const PARTS = [["new", "New", "text-sky-600"], ["in_progress", "In progress", "text-amber-600"], ["won", "Won", "text-emerald-600"],
  ["lost", "Lost", "text-red-600"], ["cancelled", "Cancelled", "text-slate-500"]];

export default function LeadsCard({ to = "/staff/leads" }) {
  const [c, setC] = useState(null);
  const [off, setOff] = useState(false);
  useEffect(() => {
    let live = true;
    const load = () => api.get("/v2/crm-leads", { params: { page_size: 1 } })
      .then((r) => { if (live) { setC(r.data.counts); setOff(false); } })
      .catch(() => { if (live) setOff(true); });
    load();
    const t = setInterval(load, 60000);
    return () => { live = false; clearInterval(t); };
  }, []);
  if (off) return null;
  const open = c ? (c.new || 0) + (c.in_progress || 0) : null;
  return (
    <Link to={to} className="block rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition hover:border-[#159DFF]/50 hover:shadow" data-testid="leads-card">
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">Open leads</span>
        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#159DFF]/10"><Target className="h-4 w-4 text-[#159DFF]" /></span>
      </div>
      <div className="mt-3 flex flex-wrap items-end gap-x-8 gap-y-3">
        <p className="text-4xl font-bold text-slate-900" data-testid="leads-card-open">{open === null ? "—" : open}</p>
        {PARTS.map(([k, label, cls]) => (
          <div key={k}><p className={`text-xl font-bold ${cls}`}>{c ? c[k] || 0 : "—"}</p><p className="text-xs text-slate-500">{label}</p></div>
        ))}
        <span className="ml-auto inline-flex items-center gap-1 text-sm font-semibold text-[#159DFF]">View leads <ArrowRight className="h-4 w-4" /></span>
      </div>
    </Link>
  );
}
